import React from "react";
import GroupActivityButton from "./GroupActivityButton";
import { useNavigate } from "react-router-dom";
import GroupCareplanList from "../GroupCareplanList";
import GroupProgramList from "../GroupProgramList";
import Loader from "../../../commonComponent/Loader";

function GroupActivityButtonList({selectedgroup}) {
  // console.log(selectedgroup)
  const [careShow, setCareShow] = React.useState(false);
  const [programShow, setProgramShow] = React.useState(false);
  const datafromApi = [
    "Programs",
    "Polls",
    // "Reports",
    "Careplans",
    "Files",
    "Events",
  ];
  const navigate = useNavigate();
  const handleClick = (name) => {
    navigate(`/group${name}`, {
      state: {
        selectedgroup: selectedgroup,
      },
    });
  };

  return (
    <>
    {selectedgroup? 
    <div className="d-flex flex-wrap gap-2 justify-content-center ">
    {datafromApi.map((name, i) => {
      return (
        <GroupActivityButton
          onClick={() => {
            handleClick(name.toLowerCase());
          }}
          key={i}
          width="30%"
          borderRadius="8px"
          padding="5px 50px"
          backgroundColor="rgba(227, 236, 237, 1)"
          border="3px solid rgba(31, 126, 120, 1)"
          color="rgba(31, 126, 120, 1)"
          fontWeight="bold"
        >
          {name}
        </GroupActivityButton>
      );
    })}

  </div> : <Loader visible='true' mainClassName="mb-5 pb-5"/>
  
  }
          {/* Modals */}
          <GroupCareplanList
          show={careShow}
          onHide={() => setCareShow(false)}
          selectedgroup={selectedgroup}
        />
        <GroupProgramList
          show={programShow}
          onHide={() => setProgramShow(false)}
          selectedgroup={selectedgroup}
        />
       </>
  );
}

export default GroupActivityButtonList;
